import * as types from '../mutation-types'
const state = {
	sliders: []
}

const actions = {
	fetchSliders ({ commit }) {
		return window.axios.get('/sliders').then((response) => {
			commit(types.STORE_SLIDERS, response.data)
			return response.data
		})
	}
}

const mutations = {
	[types.STORE_SLIDERS] (state, sliders) {
		state.sliders = sliders;
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}